import React from 'react';
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import {
	getLabelColorByStateAndDifficulty,
	getTrackColorByStateAndDifficulty,
	renderLabelHelper
} from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const renderLabel = (coords, color, onLabelClick) => renderLabelHelper(coords, color, onLabelClick, '11F', 'Track11FBlue', "8.88867188");

const Track11FBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track11FBlue" transform="translate(2104.000000, 429.000000)" className="track">
		<g id="line" transform="translate(0.190230, 0.626282)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path d="M116.80977,191.873718 L103.612045,189.356638 M91.3699242,187.373718 L42.0914982,178.67241"/>
			<path
				d="M13.8097695,121.373718 L29.4597374,71.844878 C32.5643181,62.0195363 29.0506609,51.3089482 20.7292471,45.231956 L0,30.0937263 L0,30.0937263 L16.3700247,27.8993032 L132.909989,11.1623544"/>
			<line x1="143.844191" y1="9.59203323" x2="185.80977" y2="3.5651244"/>

			<TrackArrow transform="translate(146.119345, 9.000000) rotate(-8.000000) translate(-146.119345, -9.000000) "
									points="150.119345 17 142.119345 9 150.119345 1"/>
			<TrackArrow transform="translate(89.085449, 186.990591) rotate(-175.000000) translate(-89.085449, -186.990591) "
									points="93.0854487 194.990591 85.0854487 186.990591 93.0854487 178.990591"/>
		</g>

		<path
			d="M14,122 C7.01653686,140.622568 14.1057516,161.587628 30.9580288,172.150277 L42.695638,179.507161 L42.695638,179.507161"
			id="Path" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		{renderLabel("48.233679, 4.191406", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("9.233679, 44.191406", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
		{renderLabel("1.233679, 138.191406", getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE), onLabelClick)}
	</g>
);

Track11FBlue.propTypes = trackPropTypes;

export default Track11FBlue;
